import { useTranslation } from "react-i18next";
import classNames from "classnames";
import type { ButtonProps } from "@mui/material";
import { AppButton } from "../../../../../shared/components/AppButton";
import { SoundTextIcon } from "../../../../../shared/icons/SoundTextIcon";
import styles from "../styles.module.css";
import { TButton } from "../../../../types/buttons";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";

interface Props extends ButtonProps {
  btnType: TButton;
  className?: string;
}

export const SoundToTextButton = ({ btnType, className, ...props }: Props) => {
  const { t } = useTranslation();
  const cls = classNames(styles.button, className);

  if (btnType === "icon_btn") {
    return (
      <AppIconButton className={cls} {...props}>
        <SoundTextIcon />
      </AppIconButton>
    );
  }

  return (
    <AppButton
      buttonType={"text"}
      icon={<SoundTextIcon />}
      className={cls}
      {...props}
    >
      {t("sidebar.recognize_audio_button")}
    </AppButton>
  );
};
